export function roundIfMoreThan2Decimals(value: number): number {
  const decimals = value.toString().split('.')[1];
  if (decimals && decimals.length > 2) {
    return Number(value.toFixed(2));
  }
  return value;
}
